import {
  Button,
  ContainerTile,
  H1,
  RowWrapper,
  Tile,
  Wrapper,
} from "components/styled-components/generic";
import useCheckIfMobile from "helpers/check-if-mobile";
import { FC } from "react";

interface AcSwitchProps {
  isAcOn: boolean;
  setIsAcOn: (p: boolean) => void;
}

const AcSwitch: FC<AcSwitchProps> = ({ isAcOn, setIsAcOn }) => {
  const isMobile = useCheckIfMobile();

  return (
    <ContainerTile>
      <Wrapper>
        <H1 style={{ marginTop: !isMobile ? "13px" : "15px" }}>
          Klimaanlage oder Heizung
        </H1>
      </Wrapper>
      <RowWrapper>
        <Tile>
          <Button
            onClick={() => setIsAcOn(!isAcOn)}
            active={isAcOn}
            width="85px"
          >
            an
          </Button>
        </Tile>
      </RowWrapper>
    </ContainerTile>
  );
};

export default AcSwitch;
